export const BlipType = {
  EVENT_TRACK: "application/vnd.iris.eventTrack+json",
  APPLICATION_JSON: "application/json",
  ACTIVE_CAMPAIGN: "application/vnd.iris.activecampaign.campaign+json",
} as const;
